import React, { useEffect, useState } from "react";
import axios from "axios";
import { FaEdit, FaPlus, FaTimes } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Userwallet = () => {

  const [users, setUsers] = useState([]);
  const [wallets, setWallets] = useState({});
  const [loading, setLoading] = useState(true);
  const [trades, setTrades] = useState([]);
  const [selectedTrade, setSelectedTrade] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [showCloseModal, setShowCloseModal] = useState(false);
const[tradeData,setTradesData] = useState([]);
  const [referralData, setReferralData] = useState([]);
  const [userPLMap, setUserPLMap] = useState({});
const [referralMap, setReferralMap] = useState({});

const [editItem, setEditItem] = useState(null);
const [isEditMode, setIsEditMode] = useState(false);
const [selectedTradeId, setSelectedTradeId] = useState(null);

const [selectedTradeIds, setSelectedTradeIds] = useState([]);

  const initialCloseForm = {
  id: "",
  index_name: "",
  max_wallet: "",
  amount: "",
  pl_type: "Profit",
  pl_amount: "",
  date: "",
  charges: "",
  exp_date: "",
    term: "",
    qty:'',
};

const [closeForm, setCloseForm] =
  useState(initialCloseForm);

  const [minBalance, setMinBalance] = useState("");
  const [maxBalance, setMaxBalance] = useState("");

  const [showForm, setShowForm] = useState(false);

  const [masterTradeDetails, setMasterTradeDetails] = useState([]);



  const [formData, setFormData] = useState({
    id: "",
    index_name: "",
    trade_status: "",
      amount: "",

    pl_type: "",
    pl_amount: "",
    max_wallet: "",
    date: "",
      term: "",
  });
  const [showProfitModal, setShowProfitModal] = useState(false);
  const [finalTrades, setFinalTrades] = useState([]);
const [selectedTradeUsers, setSelectedTradeUsers] = useState([]);

const [profitForm, setProfitForm] = useState({
  pl_amount: "",
  pl_type: "Profit",
  trade_date: "",
  trade_type: "Sell",
  qty: "",
  term: "CE"
});

const [form, setForm] = useState({
  user_id: "",
  index_name: "",
  trade_status: "Active",
  date: "",
  amount: "",
  pl_amount: "",
  pl_type: "Profit",
  max_wallet: "",
});

  useEffect(() => {
    fetchUsers();
    fetchTrades();
   
  }, []);


  const fetchUsers = async () => {
    try {

      const res = await axios.get(
        "https://api.statixtrading.in/api/users"
      );

      const userList = res.data.data || [];
      const filterData=userList.sort((a,b)=> b.id -a.id)

      setUsers(userList);

await Promise.all([
  fetchReferralData(userList),
  fetchTradesData(userList),
]);

      const walletData = {};

      await Promise.all(
        userList.map(async (user) => {

          try {

            const w = await axios.get(
              `https://api.statixtrading.in/api/wallet/${user.id}`
            );

            const balance =
              w.data?.data?.balance ??
              w.data?.data?.[0]?.balance ??
              0;

            walletData[user.id] = Number(balance);

       

          } catch (err) {

            walletData[user.id] = 0;

          }

        })
      );

      setWallets(walletData);
   

    } catch (error) {

      console.log(error);

    } finally {

      setLoading(false);

    }
  };



const fetchReferralData = async (users) => {
  const referralObj = {};

  await Promise.all(
    users.map(async (user) => {
      try {
        const res = await axios.get(
          `https://api.statixtrading.in/api/fetch-referal/${user.userid}`
        );

        if (res.data.success) {
          referralObj[user.id] = res.data.data.reduce(
            (sum, item) => sum + Number(item.coins || 0),
            0
          );
        } else {
          referralObj[user.id] = 0;
        }
      } catch (error) {
        referralObj[user.id] = 0;
      }
    })
  );

  setReferralMap(referralObj);
};

  
  const handleProfitChange = (e) => {
  setProfitForm({
    ...profitForm,
    [e.target.name]: e.target.value,
  });
};



const handleProfitSubmit = async (e) => {
  e.preventDefault();

  try {
    if (!selectedTrade?.id) {
      toast.success("Trade Profit Added Successfully");
      return;
    }

    const payload = {
      pl_amount: profitForm.pl_amount,
      pl_type: profitForm.pl_type,
      trade_date: profitForm.trade_date,
      trade_type: profitForm.trade_type,
      qty: profitForm.qty,
      term: profitForm.term,
      users: selectedTradeUsers,
      
    };

  

   

    const response = await axios.post(
      `https://api.statixtrading.in/api/user-trade-profit/${selectedTrade.id}`,
      payload
    );

   

    toast.success("Trade Profit Added Successfully");

    setShowProfitModal(false);
    setSelectedTrade(null);

    setProfitForm({
      pl_amount: "",
      pl_type: "Profit",
      trade_date: "",
      trade_type: "Sell",
      qty: "",
      
    });

    fetchTrades();
  } catch (error) {
  
    console.log("ERROR RESPONSE:", error?.response?.data);

    toast.error(
      error?.response?.data?.message ||
      "Something went wrong"
    );
  }
};


  const handleCloseChange = (e) => {
  setCloseForm({
    ...closeForm,
    [e.target.name]: e.target.value,
  });
};


// const handleCloseSubmit = async (e) => {

//   e.preventDefault();

//   const userIds = filteredUsers.map((user) => user.id);

//   try {

//     const payload = {
//       tId: closeForm.id,

//       index_name: closeForm.index_name,

//       max_wallet: closeForm.max_wallet,

//       amount: closeForm.amount,

//       pl_amount: closeForm.pl_amount,

//       pl_type: closeForm.pl_type,

//       charges: closeForm.charges,
//         exp_date: closeForm.exp_date,
//         term: closeForm.term,
      

//       date: closeForm.date,

//       users: userIds,
//       qty:closeForm.qty,
//     };



//     const response = await axios.put(
//       "https://api.statixtrading.in/api/closed-master-trade",
//       payload
//     );

  
  

//     toast.success("Trade Closed Successfully");
//     setCloseForm(initialCloseForm);


//     setShowCloseModal(false);

//     fetchTrades();

//   } catch (error) {

//     console.log("API ERROR =>", error);

//     console.log(
//       "ERROR RESPONSE =>",
//       error?.response?.data
//     );
//   }
// };



const handleCloseSubmit = async (e) => {
  e.preventDefault();

  const userIds = filteredUsers.map((user) => user.id);

  try {
    let payload = {};


    if (!isEditMode) {
      payload = {
        tId: closeForm.id,
        index_name: closeForm.index_name,
        max_wallet: closeForm.max_wallet,
        amount: closeForm.amount,
        pl_amount: closeForm.pl_amount,
        pl_type: closeForm.pl_type,
        charges: closeForm.charges,
        exp_date: closeForm.exp_date,
        term: closeForm.term,
        date: closeForm.date,
        users: userIds,
        qty: closeForm.qty,
      };

      await axios.put(
        "https://api.statixtrading.in/api/closed-master-trade",
        payload
      );

      toast.success("Trade Closed Successfully");
    }

  
    else {
      payload = {
        ids: selectedTradeIds,
        index_name: closeForm.index_name,
        max_wallet: closeForm.max_wallet,
        amount: closeForm.amount,
        pl_amount: closeForm.pl_amount,
        pl_type: closeForm.pl_type,
        charges: closeForm.charges,
        exp_date: closeForm.exp_date,
        term: closeForm.term,
        date: closeForm.date,
        users: userIds,
        qty: closeForm.qty,
      };

      await axios.put(
        "https://api.statixtrading.in/api/edit-master-trade",
        payload
      );

      toast.success("Trade Updated Successfully");
    }

    // reset
    setCloseForm(initialCloseForm);
    setShowCloseModal(false);
    setIsEditMode(false);
    setSelectedTradeIds([]);

    fetchTrades();
  } catch (error) {
    console.log("API ERROR =>", error);
    console.log("ERROR RESPONSE =>", error?.response?.data);
    toast.error("Something went wrong!");
  }
};


const handleUpdate = (item) => {
  setFormData({
    id: item.id,
      amount: item.amount || "",

   
    pl_type:
      item.pl_type,

    pl_amount: item.pl_amount,
    date: item.date
      ? new Date(item.date).toISOString().slice(0, 16)
      : "",
  });

  setShowModal(true);
};

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    await axios.put(
      `https://api.statixtrading.in/api/master-trade/${formData.id}`,
      {
      
       amount: formData.amount,
        pl_type: formData.pl_type,
        pl_amount: formData.pl_amount,
        date: formData.date,
      }
    );

toast.success("Updated Successfully");
    setShowModal(false);
    fetchTrades();

  } catch (error) {
    console.log(error);
  }
};
  const handleClose = (item) => {
    console.log("CLOSE:", item);
  };



const handletradeClose = (item) => {

  if (
    minBalance == null ||
    minBalance === "" ||
    maxBalance == null ||
    maxBalance === ""
  ) {

    toast.error(
      "Select Users as per Balance"
    );

    return;
  }

  setCloseForm({
    ...initialCloseForm,

    id: item.id,

    index_name:
      item.index_name || "",

    max_wallet:
      item.max_wallet || 0,
        pl_type:
    item.pl_type || "Profit",
        term:
    item.term || "",

    date: new Date()
      .toISOString()
      .slice(0, 16),
  });

  setShowCloseModal(true);
};
    const fetchTrades = async () => {
    try {
      const res = await axios.get(
        "https://api.statixtrading.in/api/today-master-trade"
      );

      if (res.data?.success) {
        setTrades(res.data.data);
      } else {
        setTrades([]);
      }
    } catch (error) {
      console.log("ERROR:", error);
    } finally {
      setLoading(false);
    }
  };



const calculateUserPL = (trades = []) => {
  let profit = 0;
  let loss = 0;
  let charges = 0;

  trades.forEach((trade) => {
    const plAmount = Number(trade.pl_amount || 0);

    if (trade.pl_type === "Profit") {
      profit += plAmount;
    } else if (trade.pl_type === "Loss") {
      loss += plAmount;
    }

    charges += Number(trade.charges || 0);
  });

  return {
    profit,
    loss,
    charges,
    netPL: profit - loss - charges,
  };
};




const fetchTradesData = async (users) => {
  try {
    const plMap = {};

    await Promise.all(
      users.map(async (user) => {
        try {
          const res = await axios.get(
            `https://api.statixtrading.in/get-trade-history/${user.id}`
          );

          const trades = res.data || [];

          plMap[user.id] = calculateUserPL(trades);

       
        } catch (error) {
          plMap[user.id] = {
            profit: 0,
            loss: 0,
            charges: 0,
            netPL: 0,
          };
        }
      })
    );

    setUserPLMap(plMap);
  } catch (error) {
    console.log(error);
  }
};


const getCurrentWallet = (userId) => {
  const depositWallet = Number(wallets[userId] || 0);

  const netPL = Number(
    userPLMap[userId]?.netPL || 0
  );

  const referralCoins = Number(
    referralMap[userId] || 0
  );

  return (
    depositWallet +
    netPL +
    referralCoins
  ).toFixed(2);
};

  const filteredUsers = users.filter((user) => {

  // const balance = wallets[user.id] || 0;
  const balance = getCurrentWallet(user.id);

  if (
    minBalance !== "" &&
    balance < Number(minBalance)
  ) {
    return false;
  }

  if (
    maxBalance !== "" &&
    balance > Number(maxBalance)
  ) {
    return false;
  }

  return true;
});


useEffect(() => {
  const uniqueClosedTrades = [];
  const masterTradeMap = [];

  const filtered = trades.filter((item) => {

    if (item.trade_status === "Active") {
      return true;
    }

    // const key = `${item.index_name}_${item.max_wallet}_${item.amount}`;


    const key = `${item.index_name?.trim().toLowerCase()}_${Number(item.max_wallet)}_${Number(item.amount)}`;

    masterTradeMap.push({
      master_trade_id: item.id,
      user_id: item.user_id,
      key,
      trade: item
    });

    if (uniqueClosedTrades.includes(key)) {
      return false;
    }

    uniqueClosedTrades.push(key);
    return true;
  });

  setFinalTrades(filtered);
  setMasterTradeDetails(masterTradeMap);
  

}, [trades]);



  const openTradeModal = () => {

    const maxWalletUser = filteredUsers.reduce(
      (prev, current) => {

        const prevWallet =
          wallets[prev?.id] || 0;

        const currentWallet =
          wallets[current?.id] || 0;

        return currentWallet > prevWallet
          ? current
          : prev;

      },
      filteredUsers[0]
    );



setForm({
  user_id: maxWalletUser?.id,
  index_name: "",
  trade_status: "Active",
  date: "",
  amount: "",
  pl_amount: "",
  pl_type: "Profit",
  max_wallet: maxBalance,
});
    setShowForm(true);
  };
const saveTrade = async () => {

  try {


    if (
      !form.index_name ||
      form.index_name.trim() === "" ||
      !form.max_wallet ||
      !form.pl_amount
    ) {

      toast.error(
        "Please fill required fields"
      );

      return;

    }

    const payload = {

      user_id:
        form.user_id,

      index_name:
        form.index_name,

      trade_status:
        "Active",

      date:
        new Date(),
          amount: Number(form.amount || 0), 

      pl_amount:
        Number(form.pl_amount || 0),

      pl_type:
        form.pl_type,

      max_wallet:
        Number(form.max_wallet || 0),
          term: form.term,

    };

    const response =
      await axios.post(
        "https://api.statixtrading.in/api/master-trade",
        payload
      );

  

    toast.success(
      response.data.message ||
      "Trade Created Successfully"
    );


    setShowForm(false);



    setForm({
      user_id: "",
      index_name: "",
      trade_status: "Active",
      date: "",
      amount:"",
      pl_amount: "",
      pl_type: "Profit",
      max_wallet: "",
        term: "",
    });


    fetchTrades();

  } catch (err) {

    console.log(err);



    toast.error(
      err?.response?.data?.message ||
      "Trade Failed"
    );

  }

};
  


  if (loading) {
    return (
      <h2 style={{ textAlign: "center" }}>
        Loading...
      </h2>
    );
  }


const handleEdit = (item) => {

  const key = `${item.index_name?.trim().toLowerCase()}_${Number(item.max_wallet)}_${Number(item.amount)}`;
  const relatedTrades = masterTradeDetails.filter(
  (t) =>
    t.trade.user_id === item.user_id &&
    t.trade.index_name === item.index_name &&
    Number(t.trade.max_wallet) === Number(item.max_wallet) &&
    Number(t.trade.amount) === Number(item.amount)
);


const tradeIds = relatedTrades.map(
  t => t.master_trade_id
);


  setEditItem(item);
  setSelectedTradeIds(tradeIds); 

  setFormData({
    index_name: item.index_name || "",
    amount: item.amount || "",
    max_wallet: item.max_wallet || "",
    term: item.term || "",
  });


};


const handleEditCloseTrade = (item) => {
  setIsEditMode(true);

  const key = `${item.index_name?.trim().toLowerCase()}_${Number(
    item.max_wallet
  )}_${Number(item.amount)}`;


  const relatedTrades = masterTradeDetails.filter(
    (t) => t.key === key
  );


  const tradeIds = relatedTrades
    .map((t) => t.master_trade_id)
    .filter(Boolean);

  setSelectedTradeIds(tradeIds);

  setCloseForm({
    id: item.id || "",
    index_name: item.index_name || "",
    amount: item.amount || "",
    max_wallet: item.max_wallet || "",
    pl_type: item.pl_type || "Profit",
    pl_amount: item.pl_amount || "",
    charges: item.charges || "",
    qty: item.qty || "",
    date: item.date || "",
    term: item.term || "",
    exp_date: item.exp_date || "", 
    tId: tradeIds,
  });

  setShowCloseModal(true);
};
return (
    <div style={styles.container}>

      <h1 style={styles.heading}>
        User Wallet
      </h1>

  
      <div style={styles.filterBox}>

        <button
          style={styles.tradeBtn}
          onClick={openTradeModal}
        >
          Start Trade
        </button>

        <input
          type="number"
          placeholder="Min Wallet"
          value={minBalance}
          onChange={(e) =>
            setMinBalance(e.target.value)
          }
          style={styles.input1}
        />

        <input
          type="number"
          placeholder="Max Wallet"
          value={maxBalance}
          onChange={(e) =>
            setMaxBalance(e.target.value)
          }
          style={styles.input1}
        />

      </div>


{trades != null && trades.length > 0 && (            <div className="my-3 w-100">
              <h2 style={styles.heading}>Today's Trade</h2>
        
              <div style={styles.card} >
                <table style={styles.table}>
                  <thead>
                    <tr>
                      <th style={styles.th}>Status</th>
                      <th style={styles.th}>Index</th>
                      {/* <th style={styles.th}>Type</th> */}
                      <th style={styles.th}>Strike Price</th>
                      <th style={styles.th}>Max Wallet</th>
                      <th style={styles.th}>P/L Amount</th>
                        <th style={styles.th}>Term</th>
                      <th style={styles.th}>Date</th>
                      <th style={styles.th}>Action</th>
                    </tr>
                  </thead>
        
                  <tbody>
                    {trades.length === 0 ? (
                      <tr>
                        <td
                          colSpan="8"
                          style={{
                            textAlign: "center",
                            padding: "20px",
                          }}
                        >
                          No Data Found
                        </td>
                      </tr>
                    ) : (
                      finalTrades.map((item) => (
                      
                        <tr key={item.id}>
                          <td style={{...styles.td,
                             color:
                                item.trade_status === "Active"
                                  ? "green"
                                  : 'red'}
                                  
                          }>{item.trade_status}</td>
        
                          <td style={styles.td}>
                            {item.index_name}
                          </td>
                                  <td style={styles.td}>
                    {item.trade_status == 'Active' ? '' : ` ₹ ${Math.round(item.amount)}`}
                          </td>
        
                
        
                          <td style={styles.td}>
                            ₹ {item.max_wallet}
                          </td>
                          <td style={{...styles.td,
                             color:
                                item.pl_type === "Profit"
                                  ? "green"
                                  : item.pl_type === "Loss"
                                  ? "red"
                                  : "#333",
                              fontWeight: "bold",}
                          }>
                            {item.pl_type === "Profit" ? '+' : '-'}
                            {item.pl_amount}
                          </td>
<td style={styles.td}>
  {item.term || "-"}
</td>
        
                          <td style={styles.td}>
                            {item.date
                              ? new Date(item.date).toLocaleString()
                              : "-"}
                          </td>
        
                          <td style={styles.td}>
                            {item.trade_status == 'Active' && (
                              <>
                            <button
                              style={styles.updateBtn}
                              onClick={() => handleUpdate(item)}
                            >
                              <FaEdit />
                            </button>
        
                            <button
                            className="text-danger"
                              style={styles.updateBtn}
                              onClick={() => handletradeClose(item)}
                            >
                              <FaTimes />
                            </button>
        </>)}                 
        
{item.trade_status === "Closed" && (
  <button
    style={styles.updateBtn}
    onClick={() => handleEditCloseTrade(item)}
//     onClick={() => {
//   const key =
//     `${item.index_name}_${item.max_wallet}_${item.amount}`;

//   const relatedTrades = masterTradeDetails.filter(
//     (trade) => trade.key === key
//   );


//   // const tradeIds = relatedTrades.map(t => t.id);
//   const tradeIds = relatedTrades.map(
//   t => t.master_trade_id
// );

// setSelectedTradeIds(tradeIds);

//   setSelectedTrade(item);
//   setSelectedTradeUsers(relatedTrades);

//   // store all ids for edit
//   setCloseForm({
//     ...item,
//     ids: tradeIds,  
//   });

//   setIsEditMode(true);
//   setShowCloseModal(true);
// }}
  >
    <FaEdit />
  </button>
)}

 {/* {item.trade_status === 'Closed' && (
  <button
    style={styles.updateBtn}
    onClick={() => {

      const key =
        `${item.index_name}_${item.max_wallet}_${item.amount}`;

      // Get all actual master trades for this displayed trade
      const relatedTrades = masterTradeDetails.filter(
        (trade) => trade.key === key
      );

  
      setSelectedTrade(item);

      // Store all related master trade ids
      setSelectedTradeUsers(relatedTrades);

      setProfitForm({
        pl_amount: "",
        pl_type: "Profit",
        trade_date: "",
        trade_type: "Sell",
        qty: "",
        term: "CE",
      });

      setShowProfitModal(true);
    }}
  >
    <FaPlus />
  </button>
)} */}

         </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

              {showCloseModal && (
        
          <div style={styles.modalOverlay}>
        
            <div style={styles.modal}>
        
              <div className="d-flex justify-content-between">
        
                <h2 style={{ margin: 0 }}>
                  Close Trade
                </h2>
        
                <button
                  style={styles.closeIconBtn}
                  onClick={() =>{
                    setShowCloseModal(false);
                    setIsEditMode(null);
                  }
                  }
                >
                  ✕
                </button>
        
              </div>
        
              {/* <form onSubmit={handleCloseSubmit}> */}
              <form
  onSubmit={handleCloseSubmit}
  autoComplete="off"
>
           
             <label style={styles.label}>
        strike price
          </label>
                <input
                  type="number"
                  name="amount"
                  placeholder="Amount"
                    autoComplete="off"
                  value={closeForm.amount}
                  onChange={handleCloseChange}
                  style={styles.input}
                />
           
             <label style={styles.label}>
            P/L Type
          </label>
                <select
                  name="pl_type"
                  value={closeForm.pl_type}
                    autoComplete="off"
                  onChange={handleCloseChange}
                  style={styles.input}
                >
                  <option value="Profit">
  Profit (+)
</option>

<option value="Loss">
  Loss (-)
</option>
                </select>
                   
             <label style={styles.label}>
            P/L Amount
          </label>
        
                <input
                  type="number"
                  name="pl_amount"
                  placeholder="P/L Amount"
                    autoComplete="off"
                  value={closeForm.pl_amount}
                  onChange={handleCloseChange}
                  style={styles.input}
                />


                  <label style={styles.label}>
            Trade Charges
          </label>
        
                <input
                  type="number"
                  name="charges"
                  placeholder="Charges"
                    autoComplete="off"
                  value={closeForm.charges}
                  onChange={handleCloseChange}
                  style={styles.input}
                />
           
                  <label style={styles.label}>
          Quantity
          </label>
        
                <input
                  type="number"
                  name="qty"
                  placeholder="Quantity"
                    
                  value={closeForm.qty}
                  onChange={handleCloseChange}
                  style={styles.input}
                />
           
             <label style={styles.label}>
            Date & Time
          </label>
                <input
                  type="datetime-local"
                  name="date"
                    
                  value={closeForm.date}
                  onChange={handleCloseChange}
                  style={styles.input}
                />
                                  <label style={styles.label}>
      Term
          </label>
                <input
                  type="text"
                  name="term"
                    autoComplete="off"
                  value={closeForm.term}
                  onChange={handleCloseChange}
                  style={styles.input}
                />
                    <label style={styles.label}>
      Expiry Date
          </label>
                <input
                  type="datetime-local"
                  name="exp_date"
                    autoComplete="off"
                  value={closeForm.exp_date}
                  onChange={handleCloseChange}
                  style={styles.input}
                />
        
                <button
                  type="submit"
                  style={styles.saveBtn}
                >
                   {isEditMode ? "Update Trade" : "Close Trade"}
                </button>
        
              </form>
        
            </div>
        
          </div>
        
        )}
        
           
         {showModal && (
          <div style={styles.modalOverlay}>
            <div style={styles.modal}>
        
           
              <div className="d-flex justify-content-between">
                <h2 style={{ margin: 0 }}>Edit Trade</h2>
        
         
                <button
                  style={styles.closeIconBtn}
                  onClick={() => setShowModal(false)}
                >
                  ✕
                </button>
              </div>
        
              <form onSubmit={handleSubmit}>
           
             <label style={styles.label}>
            P/L Type
          </label>
        
                <select
                  name="pl_type"
                  value={formData.pl_type}
                  onChange={handleChange}
                  style={styles.input}
                >
                  <option value="+">Profit (+)</option>
                  <option value="-">Loss (-)</option>
                </select>
                  <label style={styles.label}>
            P/L Amount
          </label>
        
                <input
                  type="number"
                  name="pl_amount"
                  placeholder="P/L Amount"
                  value={formData.pl_amount}
                  onChange={handleChange}
                  style={styles.input}
                />
                  <label style={styles.label}>
            Date & Time
          </label>
        
        
              
                <input
                  type="datetime-local"
                  name="date"
                  value={formData.date}
                  onChange={handleChange}
                  style={styles.input}
                />
                <label style={styles.label}>
  Max Amount
</label>

<input
  type="number"
  name="amount"
  placeholder="Max Amount"
  value={formData.amount}
  onChange={handleChange}
  style={styles.input}
/>
        
                <div style={styles.modalBtnBox}>
                  <button
                    type="submit"
                    style={styles.saveBtn}
                  >
                    Update
                  </button>
        
              
                </div>
              </form>
            </div>
          </div>
        )}
            </div>
      )}

   
      <div style={styles.card}>
      <h2 style={styles.heading}>Users</h2>
        
        <div style={styles.tableWrapper}>

          <table style={styles.table}>
<thead>
  <tr>
    <th style={styles.th}>SN</th>
    <th style={styles.th}>User ID</th>
    <th style={styles.th}>Mobile</th>
    <th style={styles.th}>Deposit Wallet</th>
       <th style={styles.th}>Current Wallet</th>
  
  </tr>
</thead>

<tbody>

  {filteredUsers.map((user,index) => (

    <tr key={user.id}>

      <td style={styles.td}>
        {filteredUsers.length-index}
      </td>

      <td style={styles.td}>
        {user.userid}
      </td>


      <td style={styles.td}>
        {user.mobile_no}
      </td>

      <td style={styles.td}>
        ₹ {wallets[user.id] || 0}
      </td>
    <td style={styles.td}>
  ₹ {getCurrentWallet(user.id)}
</td>

    </tr>

  ))}

</tbody>

          </table>

        </div>

      </div>
      {showProfitModal && (
  <div style={styles.modalOverlay}>
    <div style={styles.modal}>

      <div className="d-flex justify-content-between">
        <h2 style={{ margin: 0 }}>Add Trade Profit</h2>

        <button
          style={styles.closeIconBtn}
          onClick={() => setShowProfitModal(false)}
        >
          ✕
        </button>
      </div>

      <form onSubmit={handleProfitSubmit}>

        <label style={styles.label}>price</label>
        <input
          type="number"
          name="pl_amount"
          value={profitForm.pl_amount}
          onChange={handleProfitChange}
          style={styles.input}
        />

        <label style={styles.label}>P/L Type</label>
        <select
          name="pl_type"
          value={profitForm.pl_type}
          onChange={handleProfitChange}
          style={styles.input}
        >
          <option value="Profit">Profit</option>
          <option value="Loss">Loss</option>
        </select>

        <label style={styles.label}>Trade Type</label>
        <select
          name="trade_type"
          value={profitForm.trade_type}
          onChange={handleProfitChange}
          style={styles.input}
        >
          <option value="Buy">Buy</option>
          <option value="Sell">Sell</option>
        </select>

        <label style={styles.label}>Quantity</label>
        <input
          type="number"
          name="qty"
          value={profitForm.qty}
          onChange={handleProfitChange}
          style={styles.input}
        />
      
<label style={styles.label}>
  Term
</label>

<input
  type="text"
  name="term"
  placeholder="Enter Term"
  value={profitForm.term}
  onChange={handleProfitChange}
  style={styles.input}
/>

        <label style={styles.label}>Date & Time</label>
        <input
          type="datetime-local"
          name="trade_date"
          value={profitForm.trade_date}
          onChange={handleProfitChange}
          style={styles.input}
          step="1"
        />

        <button type="submit" style={styles.saveBtn}>
          Save
        </button>

      </form>

    </div>
  </div>
)}

     
{showForm && (

  <div style={styles.modalOverlay}>

    <div style={styles.modal}>

   
      <button
        onClick={() => setShowForm(false)}
        style={styles.closeBtn}
      >
        ✖
      </button>

      <h3 style={{ textAlign: "center" }}>
        Start Trade
      </h3>
        <label style={styles.label}>
    Index Name
  </label>

      <input
        placeholder="Index Name"
        value={form.index_name}
        onChange={(e) =>
          setForm({
            ...form,
            index_name: e.target.value,
          })
        }
        style={styles.input}
      />

  
  <label style={styles.label}>
    Auto Max Wallet
  </label>
      <input
        type="number"
        placeholder="Auto Max Wallet"
        value={form.max_wallet}
        // readOnly
         onChange={(e) =>
          setForm({
            ...form,
            max_wallet: e.target.value,
          })
        }
        style={{
          ...styles.input,
          // background: "#f1f1f1",
        }}
      />
   
     <label style={styles.label}>
    P/L Type
  </label>
      <select
        value={form.pl_type}
        onChange={(e) =>
          setForm({
            ...form,
            pl_type: e.target.value,
          })
        }
        style={styles.input}
      >
        <option value="Profit">
          Profit
        </option>

        <option value="Loss">
          Loss
        </option>
      </select>

  <label style={styles.label}>
  P/L Amount
  </label>

<input
  type="number"
  placeholder="P/L Amount"
  value={form.pl_amount}
  onChange={(e) =>
    setForm({
      ...form,
      pl_amount: e.target.value,
    })
  }
  style={styles.input}
/>

<label style={styles.label}>
  Max Amount
</label>

<input
  type="text"
  placeholder="Enter max amount"
  value={form.amount}
  onChange={(e) =>
    setForm({
      ...form,
      amount: e.target.value,
    })
  }
  style={styles.input}
/>


      <button
        style={styles.saveBtn}
        onClick={saveTrade}
      >
        Save Trade
      </button>

    </div>

  </div>

)}




    <ToastContainer
      position="top-center"
      autoClose={3000}
    />
    </div>
    
  );
};


const styles = {
container: {
  minHeight: "100vh",
  background: "#f4f6f9",
  padding: "15px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: "100%",
  overflowX: "hidden",
},


heading: {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "10px",
  marginBottom: "20px",
  color: "#1e293b",
  fontWeight: "700",
  fontSize: "30px",
},

filterBox: {
  display: "flex",
  flexWrap: "wrap",
  gap: "10px",
  justifyContent: "center",
  marginBottom: "15px",
  width: "100%",
},

input1: {
  flex: "1 1 180px",
  minWidth: "120px",
  padding: "10px",
  border: "1px solid #ccc",
  borderRadius: "6px",
},

tradeBtn: {
  padding: "10px 16px",
  background: "#4c4d4c",
  color: "#fff",
  border: "none",
  borderRadius: "6px",
  cursor: "pointer",
  minWidth: "140px",
},

card: {
  width: "100%",
  background: "#fff",
  padding: "15px",
  borderRadius: "10px",
  overflowX: "auto",
},

tableWrapper: {
  width: "100%",
  overflowX: "auto",
},

table: {
  width: "100%",
  minWidth: "700px",
  borderCollapse: "collapse",
},

th: {
  background: "#a8aeb6",
  color: "#fff",
  padding: "10px",
  whiteSpace: "nowrap",
  fontSize: "14px",
},

td: {
  padding: "10px",
  borderBottom: "1px solid #eee",
  whiteSpace: "nowrap",
  fontSize: "14px",
},

modalOverlay: {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "rgba(0,0,0,0.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 999,
  padding: "10px",
},

modal: {
  background: "#fff",
  padding: "20px",
  borderRadius: "10px",
  width: "100%",
  maxWidth: "400px",
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  position: "relative",
  maxHeight: "90vh",
  overflowY: "auto",
},

saveBtn: {
  padding: "12px",
  background: "grey",
  color: "#fff",
  border: "none",
  borderRadius: "6px",
  cursor: "pointer",
  width: "100%",
},

closeBtn: {
  position: "absolute",
  top: "10px",
  right: "10px",
  border: "none",
  background: "transparent",
  fontSize: "18px",
  cursor: "pointer",
  color: "#333",
},

closeIconBtn: {
  background: "transparent",
  border: "none",
  fontSize: "20px",
  cursor: "pointer",
  color: "#555",
},

input: {
  width: "100%",
  padding: "10px",
  marginBottom: "12px",
  borderRadius: "5px",
  border: "1px solid #ccc",
  fontSize: "14px",
  boxSizing: "border-box",
},

updateBtn: {
  padding: "8px 10px",
  marginRight: "5px",
  color: "#333",
  border: "none",
  borderRadius: "5px",
  cursor: "pointer",
  marginBottom: "5px",
},
};

export default Userwallet;